import styled, { css } from 'styled-components';
export const Container = styled.div``;

export const OptionsWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
  padding: 20px 0;
`;

export const Option = styled.div<{ isSelected: boolean }>`
  ${({ theme, isSelected }) => css`
    padding: 15px 16px;
    border: 1.5px solid ${isSelected ? theme.colors.blueEinstein : theme.colors.colorGray300};
    background-color: ${isSelected ? '#EBF1F6' : '#fff'};
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    cursor: pointer;
  `}
`;

export const Info = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.colorGray400};
    font-weight: 600;
  `}
`;

export const LabelOption = styled.label`
  ${({ theme }) => css`
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    color: ${theme.colors.colorGray500};
  `}
`;
